import { Component, OnInit, ViewChild } from '@angular/core';
import { UserManagementServiceService } from '../user-management/user-management-service.service';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CommonServiceService } from 'src/app/pages/services/common-service.service';
import { MatSelect, MatSelectChange } from '@angular/material/select';

@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.scss']
})
export class UserProfileComponent implements OnInit {
  ADMIN_ROLE = 1;

  maxEmployeeCount = 1000000;

  userDetail = true;
  userdata: any = sessionStorage.getItem('userdata');
  userAllDetails: any = [];
  public userFormDetails !: FormGroup ;
  permissionModule = JSON.parse(sessionStorage.getItem('userPermission') || '[]');
  userData = JSON.parse(sessionStorage.getItem('userdata') || '{}');
  permissionAllowedModule: any = [];
  currentIndex = 0;
  getInitialModulePermission: any = [];
  files: any = [];
  imageAllData: any = [];
  putAPIurl: any;
  payloadURL: any = '';
  isEditMode = false;
  imgURL: any = '';
  showImage: any;
  countrys: any = [];
  sectorNames: any = [];
  msmeNames: any = [];
  userRoles: any = [];
  showCountryDropdown = false;
  selectedCountry: any;

  userAllData: any = [];
  adminData: any = JSON.parse(sessionStorage.getItem('userdata') || '{}');
  isAdmin = false;
  showRequestChangeForm = false;
  requestChangeForm!: FormGroup;

  @ViewChild('userRole') select: MatSelect | undefined;

  constructor(
    private userService: UserManagementServiceService,
    private formBuilder: FormBuilder,
    private snackBar: MatSnackBar,
    private commonService: CommonServiceService
  ) {
    this.getUserRoleDetails();
    this.getCountryDetails();
    this.getSectorDetails();
    this.getMsmeDetails();
  }

  ngOnInit(): void {
    this.createUserForm();
    this.userdata = JSON.parse(this.userdata);
    this.isAdmin = this.userData?.userlevel_id === this.ADMIN_ROLE;
    this.getUserInfo();
    this.getPermissionModule();

    this.commonService.formGetMethod('msme-classification/list', { order: 'DESC', key: 'max_employee_count' }).subscribe((res: any) => {
      if (res && res.data && res.data.length) {
        this.maxEmployeeCount = res.data[0].max_employee_count;
      }
    });
  }

  preventKeyboardInput(event: KeyboardEvent): void {
    if (event) {
    return;
    }
  }

  viewUserDetail(): void {
    this.userDetail = !this.userDetail;
    if (!this.userDetail){
    this.prefieldData();
   }
  }
  createUserForm(): void {
    this.userFormDetails = this.formBuilder.group({
      userName: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      userRole: ['', Validators.required],
      sectorName: [''],
      countryName: [''],
      msmeName: [''],
      employeeCount: [''],
    });
    this.requestChangeForm = this.formBuilder.group({
      newEmployeeCount: ['', [Validators.required, Validators.min(1)]],
    });
  }

  async getCountryDetails(): Promise<void> {
    await this.userService.countryDetails().subscribe((res: any) => {
      if (res.success){
        if (this.adminData?.userlevel_id !== this.ADMIN_ROLE){
          res.data = res.data.filter((response: any) => this.adminData?.country_id ? response.id === this.adminData?.country_id : true);
        }
        this.countrys = res.data;
      }
    }, (error: any) => {
      this.openSnackBar([error?.message || 'Failed !'] , '');
    });
  }

  async getSectorDetails(): Promise<void> {
    await this.userService.sectorNameDetails().subscribe((res: any) => {
      if (res.success){
        if (this.adminData?.userlevel_id !== this.ADMIN_ROLE){
          res.data = res.data.filter((response: any) => this.adminData?.sector_id ? response.id === this.adminData?.sector_id : true);
        }
        this.sectorNames = res.data;
      }
    }, (error: any) => {
      this.openSnackBar([error?.message || 'Failed !'] , '');
    });
  }

  async getMsmeDetails(): Promise<void> {
    await this.userService.msmeNameDetails().subscribe((res: any) => {
      if (res.success){
        if (this.adminData?.userlevel_id !== 1){
          res.data = res.data.filter((response: any) => this.adminData?.msme_id ? response.id === this.adminData?.msme_id : true);
        }
        this.msmeNames = res.data;
      }
    }, (error: any) => {
      this.openSnackBar([error?.message || 'Failed !'] , '');
    });
  }

  async getUserRoleDetails(): Promise<void> {
    const currentRoleId: number = this.adminData?.userlevel_id === this.ADMIN_ROLE ? 0 : this.adminData?.userlevel_id;
    this.userService.UserRoleDetails(currentRoleId).subscribe((res: any) => {
      if (res.success){
        this.userRoles = res.data;
      }
    }, (error: any) => {
      this.openSnackBar([error?.message || 'Failed !'] , '');
    });
  }

  countryChangeHandler(event: MatSelectChange): void {
    this.selectedCountry = event.value.id;

    if (event?.value?.id){
      this.sectorNames = [];
      this.msmeNames = [];
      this.userFormDetails.patchValue({
        sectorName: [],
        msmeName: []
      });
    }
  }

  sectorChangeHandler(event: MatSelectChange): void {
    if (event?.value?.id){
      this.msmeNames = [];
      this.userFormDetails.patchValue({
        msmeName: []
      });
    }
  }

  onEmployeeCountBlur(): void {
    if (this.userFormDetails?.controls.employeeCount?.value > this.maxEmployeeCount) {
      this.userFormDetails.get('employeeCount')?.setErrors({ maxEmployeeCountError: true });
    }
  }

  updateUser(): void {
    if (this.userFormDetails?.invalid){
      this.openSnackBar(['All field are required !!'], '', 'warning');
    }
    const payload = {
      name : this.userFormDetails?.controls.userName.value,
      email : this.userFormDetails?.controls.email.value,
      photo : this.payloadURL,
      country_id : this.showCountryDropdown && this.userFormDetails?.controls.countryName ?
        this.userFormDetails?.controls.countryName.value?.id : null,
      sector_id : this.userFormDetails?.controls.sectorName ? this.userFormDetails?.controls.sectorName.value?.id : null,
      msme_id : this.userFormDetails?.controls.msmeName ? this.userFormDetails?.controls.msmeName.value?.id : null,
      employeeCount : this.userFormDetails?.controls.employeeCount ? this.userFormDetails?.controls.employeeCount.value : null,
    };


    this.userService.updateUser(this.userdata.id, payload).subscribe((res: any) => {
        if (res.success){
          this.userDetail = true;
          this.getUserInfo(true);
          this.getTargetterUserData(payload.email, res?.message);
        }
      }, (error: any) => {
        this.showImage = '';
        this.openSnackBar([error?.message || 'Failed !'] , '');
      });
  }

  getTargetterUserData(userEmail: any, responseMsg: any): void {
    const endpoint = `/admin/submission?data.email=${this.userAllDetails.email}`;
    const payload = {
      endpoint,
      headers: {
        'Content-Type': 'application/json'
      },
      requestBody: {},
      method: 'GET'
    };
    this.commonService.targettedUserData(payload).subscribe((res: any) => {
      if (res.length){
        this.userAllData = res;
        this.updateUserData(this.userAllData, userEmail, responseMsg);
      }
    });
  }

  updateUserData(userData: any, userEamil: any, responseMsg: any): void {
    const endpoint = `/admin/submission/${userData[0]._id}`;
    const payload = {
      endpoint,
      headers: {
        'Content-Type': 'application/json'
      },
      requestBody: {
        data: {
          email: userEamil,
    }
    },
      method: 'PUT'
    };
    this.commonService.updateUserForIpsa(payload).subscribe(res => {
        if (res){
          this.openSnackBar([responseMsg || 'Created Successfully '] , '', 'success');
        }
      });

  }

  get f(): any {
    return this.userFormDetails.controls;
  }
  numberOnly(event: any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
  getUserInfo(isPrefield: boolean= false): void {
    this.userService.getProfileDetailsById(this.userdata.id).subscribe((res: any) => {
      if (res.success){
        this.userAllDetails = res.data[0];
        this.showImage = this.userAllDetails.photo;
        this.showCountryDropdown = this.userAllDetails?.userlevel_id !== this.ADMIN_ROLE;
        this.isAdmin = this.userData?.userlevel_id === this.ADMIN_ROLE;
        this.userService.isProfile.next(true);
        if (isPrefield){
          this.prefieldData();
        }
        if (this.requestChangeForm && this.userAllDetails?.employeeCount != null) {
          this.requestChangeForm.patchValue({ newEmployeeCount: this.userAllDetails.employeeCount });
        }
      }
    });
  }
  getPermissionModule(): void {
    this.permissionAllowedModule = this.permissionModule[0].authenicationJson.filter((el: any) => {
      if (el?.isAction  || el?.authentication.some((e: any) => e?.isAction)) { return el; }
    });
    this.getInitialModulePermission = this.permissionAllowedModule[this.currentIndex];
  }
  changeTabs(event: any, index: number): void {
    this.currentIndex = index;
    this.getInitialModulePermission = this.permissionAllowedModule[this.currentIndex];
  }

  // file upload
  imageInputClickHandler(event: any): void {
    document?.getElementById('form-icon-input')?.click();
}

  onFileDropped(event: any): void {

    this.files = [];
    this.prepareFilesList(event);


  }
  async imageInputChangeHandler(event: any): Promise<void> {
    this.fileBrowseHandler(event);
  }
   fileBrowseHandler(files: any): void {
    const maximumFileSize = 5 * 1024 * 1024; // 5MB in bytes
    const currentFileSize = files?.target?.files[0]?.size;

    if (currentFileSize > maximumFileSize){
      files.target.value = null;
      this.openSnackBar(['Please upload file under 5 MB !'] , '');
      return ;
    }
    const isFileExtensionValid: boolean = this.imageFileExtension(files.target.files[0].type);
    if (!isFileExtensionValid) {
        this.openSnackBar(['Please enter image icon in png,jpg,jpeg']);
        return;
    }
    const payload = [{
        file_name: files.target.files[0].name,
        mime_type: files.target.files[0].type
      }];
    this.commonService.uploadImage(payload).subscribe((res: any) => {
        if (res.success){
          this.imageAllData = res.data;
          this.imageAllData.forEach((ele: any) => {
            this.putAPIurl = ele?.url;
            this.payloadURL = ele?.file_url;
          });
          this.commonService.imagePUTapi(this.putAPIurl, files.target.files[0]).subscribe((uploadRes: any) => {
            this.showImage = this.payloadURL;

          });
        }
      });


    this.files = [];
    this.prepareFilesList(files.target.files);
  }
  prepareFilesList(files: Array<any>): void {
    for (const item of files) {

      item.progress = 0;
      this.files.push(item);
    }
    this.uploadFilesSimulator(0);
  }
  uploadFilesSimulator(index: number): void {
    setTimeout(() => {
      if (index === this.files.length) {
        return;
      } else {
        const progressInterval = setInterval(() => {
          if (this.files[index].progress === 100) {
            clearInterval(progressInterval);
            this.uploadFilesSimulator(index + 1);
          } else {
            this.files[index].progress += 5;
          }
        }, 200);
      }
    }, 1000);
  }
  deleteFile(index: number): void {
    this.files.splice(index, 1);
    this.payloadURL = '';
    this.imgURL = '';
    if (this.files.length === 0) {
    }
  }
  openDocument(): void {
    window.open(this.imgURL);
  }
  imageFileExtension(type: string): boolean {
    if (type === 'image/png' || type === 'image/jpeg' || type === 'image/jpg') {
        return true;
    }
    return false;
}
prefieldData(): void {
  this.payloadURL = this.userAllDetails.photo;
  this.showImage = this.userAllDetails.photo;

  const countryDetail = this.countrys.find((el: any) => el.id === this.userAllDetails?.country_id);
  const sectorDetail = this.sectorNames.find((el: any) => el.id === this.userAllDetails?.sector_id);
  const msmeDetail = this.msmeNames.find((el: any) => el.id === this.userAllDetails?.msme_id);
  const roleDetail = this.userRoles.find((el: any) => el.id === this.userAllDetails?.role_id);

  this.userFormDetails.patchValue({
    userName: this.userAllDetails.name ? this.userAllDetails.name : '',
    email: this.userAllDetails.email ? this.userAllDetails.email : '',
    userRole: roleDetail || '',
    countryName: countryDetail || '',
    sectorName: sectorDetail || '',
    msmeName: msmeDetail || '',
    employeeCount: this.userAllDetails.employeeCount || '',
  });

}
  /** Template-safe accessors for flattened API keys (avoids ?.['key'] and ?? in template). */
  get profileMsmeName(): string {
    const u = this.userAllDetails;
    return (u && (u['msme.name'] || (u.msme && u.msme.name))) || '---';
  }
  get profileSectorName(): string {
    const u = this.userAllDetails;
    return (u && (u['sector.name'] || (u.sector && u.sector.name))) || '---';
  }
  get profileMsmeClassificationType(): string {
    const u = this.userAllDetails;
    return (u && (u['msme_classification.type'] || (u.msme_classification && u.msme_classification.type))) || '---';
  }
  get profileEmployeeCount(): string {
    const u = this.userAllDetails;
    return u && u.employeeCount != null ? String(u.employeeCount) : '---';
  }
  get profileEmployeeCountOrEmpty(): string {
    const u = this.userAllDetails;
    return u && u.employeeCount != null ? String(u.employeeCount) : '';
  }
  get profileEnterpriseBadge(): string {
    const t = this.profileMsmeClassificationType;
    return t !== '---' ? t + ' Enterprise' : '---';
  }

  openSnackBar(message: any, action = '', className= 'parmary'): void {
    this.snackBar.open(message, action, {
    duration: 3000,
    panelClass: [className]
  });
}

  openRequestChangeForm(): void {
    this.showRequestChangeForm = true;
    this.requestChangeForm.patchValue({ newEmployeeCount: this.profileEmployeeCountOrEmpty || '' });
  }

  cancelRequestChange(): void {
    this.showRequestChangeForm = false;
  }

  submitRequestChange(): void {
    if (this.requestChangeForm?.invalid) {
      this.openSnackBar(['Please enter a valid new employee count.'], '', 'warning');
      return;
    }
    const newCount = Number(this.requestChangeForm.get('newEmployeeCount')?.value);
    if (newCount > this.maxEmployeeCount) {
      this.openSnackBar(['Employee count exceeds maximum allowed.'], '');
      return;
    }
    const currentCount = this.userAllDetails?.employeeCount ?? 0;
    if (newCount === currentCount) {
      this.openSnackBar(['New count must be different from current count.'], '');
      return;
    }
    const payload = {
      name: this.userAllDetails?.name,
      email: this.userAllDetails?.email,
      photo: this.payloadURL || this.userAllDetails?.photo,
      employeeCount: newCount,
    };
    this.userService.updateUser(String(this.userdata.id), payload).subscribe((res: any) => {
      if (res?.success) {
        this.openSnackBar([res?.message || 'Change request submitted successfully.'], '', 'success');
        this.showRequestChangeForm = false;
        this.getUserInfo();
      }
    }, (error: any) => {
      this.openSnackBar([error?.message || 'Failed to submit request.'], '');
    });
  }
}
